<div class="dot-container">
  <div class="cdk-visually-hidden sr-only" aria-live="polite">Updating...</div>
  <div class="dot-flashing"></div>
</div>
